/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
/*import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';*/
/*import { Module, Node } from '@msdyn365-commerce-modules/utilities';*/
import * as React from 'react';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { ILobasProductDocumentAttributeViewProps } from './lobas-product-document-attribute';

const LobasProductDocumentAttributeView: React.FC<ILobasProductDocumentAttributeViewProps> = props => {
    if (
        ArrayExtensions.hasElements(props.lobasProductDocumentAttributeContainer) &&
        props.lobasProductDocumentAttributeContainer[0] !== null
    ) {
        return (
            <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
                {props.lobasProductDocumentAttributeContainer}
            </div>
        );
    }
    return <></>;
};

export default LobasProductDocumentAttributeView;
